import * as React from 'react';
import withStyles from 'react-jss';
import { CssType,
  ThemeType} from '../../../../theming/jssTypes';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'src/design-system/components/atoms';

const styles = (theme: ThemeType): CssType => ({
  loaderContainer: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    top: theme.spacing[0],
    left: theme.spacing[0],
    zIndex: -1,
  },
});

const Loader = (props) => {
  const { classes, zIndex, top, size, backdropBlur, left, className, theme } = props;
  return (
    <div className={className || classes.loaderContainer} style={{
        zIndex: (zIndex !== null || zIndex !== undefined) ? zIndex : -1,
        top: top ? top : theme.spacing[0],
        left: left ? left : theme.spacing[0],
        backdropFilter: backdropBlur ? 'blur(1px)' : null,
      }}>
      <Spin indicator={
        <LoadingOutlined style={{ fontSize: size ? size : theme.typography.fontSize.xxxl }} spin />
      } />
    </div>
  );
};
export default withStyles(styles, { injectTheme: true })(Loader);
